var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"quiz-review-assign"},[_c('base-title',{staticClass:"sticky-title",attrs:{"title":_vm.$t('assignment')}}),_c('quiz-assign')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }